// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_22oEvHQmhiIhEarwVNlBle","space":"_1v4VBQIM9ITUK3kp728e8A","menu":"_1oRxIvRf5ueG1O9WpuzftM","open":"_35EL_wZWLO44V-MvI7kCvA","header":"_1InVUs1Z1ErxvPRLxiwJnN","avatar":"_2LNvjsiuYmmLg6LRuFbNZu","info":"_1BdWm65oGjSMIou0c8CaQt","name":"_3Ra_OC2tZhRuu6oYqVmP91","role":"_3WkrwqZTmvhcnBOYIoX6fn"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/NavigationBar/components/AccountMenu/styles.scss
// module id = 619
// module chunks = 11